<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Clock In/Out</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!successMessage">
    <form (ngSubmit)="loadStaffMember()">
      <div class="form-group">
        <label for="pinInput">Enter PIN</label>
        <input type="password" class="form-control" id="pinInput" name="pinInput" required
               ngbautofocus
               [(ngModel)]="pinInput" (ngModelChange)="onPinChange()">
      </div>
      <button type="submit" class="btn btn-block btn-primary"
              [class.disabled]="!canSubmitPin()"
              [disabled]="!canSubmitPin()">
        {{ loadingStaffMember ? 'Loading...' : 'Submit PIN' }}
      </button>
    </form>
    <div class="alert alert-danger mt-2" role="alert" *ngIf="staffMemberNotFound">
      PIN not found.
    </div>

    <ng-container *ngIf="staffMember">
      <hr>

      <p>
        <b>PIN found</b> <br>
        Name: <b>{{ staffMember.first_name }} {{staffMember.last_name }}</b>
        <ng-container *ngIf="staffMember.clocked_in_at">
          <br>
          Clocked in at: <b>{{ timeStringFromISO8601(staffMember.clocked_in_at)}}</b>
        </ng-container>
      </p>

      <div class="alert alert-danger mt-2" role="alert" *ngIf="clockInOutErrorMessage">
        {{ clockInOutErrorMessage }}
      </div>
    </ng-container>

    <ng-container *ngIf="staffMember && !staffMember.clocked_in_at">
      <div class="form-group" *ngIf="!loadingRoles && (roles.length > 0)">
        <label for="pinInput">Select a role in order to clock in</label>
        <select class="custom-select" name="roleIdInput"
                [(ngModel)]="roleIdInput">
          <option [ngValue]="null" class="text-muted">---</option>
          <option *ngFor="let role of roles" [ngValue]="role.id">
            {{ role.name }}
          </option>
        </select>
      </div>

      <button type="button" class="btn btn-block btn-primary"
              (click)="submitClockIn()"
              [class.disabled]="!canSubmitClockIn()"
              [disabled]="!canSubmitClockIn()">
        {{ (loadingClockInOut || loadingRoles) ? 'Loading...' : 'Clock In' }}
      </button>
    </ng-container>

    <ng-container *ngIf="staffMember && staffMember.clocked_in_at">
      <button type="button" class="btn btn-block btn-primary"
              (click)="submitClockOut()"
              [class.disabled]="loadingClockInOut"
              [disabled]="loadingClockInOut">
        {{ loadingClockInOut ? 'Loading...' : 'Clock Out' }}
      </button>
    </ng-container>
  </div>

  <div class="modal-body" *ngIf="successMessage">
    <div class="alert alert-success">{{ successMessage }}</div>

    <button type="button" class="btn btn-block btn-secondary"
            (click)="activeModal.dismiss()">
      Close
    </button>
  </div>

</ng-container>
